import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { themes } from '../styles/theme';

const ThemeContext = createContext({});

export const useTheme = () => useContext(ThemeContext);

const THEME_KEY = 'cardchase-theme';

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    // Check localStorage first, default to dark
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(THEME_KEY);
      return saved === 'light' ? 'light' : 'dark';
    }
    return 'dark';
  });

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
    localStorage.setItem(THEME_KEY, mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const setTheme = (newMode) => {
    if (newMode === 'dark' || newMode === 'light') {
      setMode(newMode);
    }
  };

  const value = useMemo(() => ({
    mode,
    isDark: mode === 'dark',
    isLight: mode === 'light',
    theme: themes[mode],
    toggleTheme,
    setTheme,
  }), [mode]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
